class InstaFeedSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.insta-feed-wrap');

    if (!slider) return;

    this.swiper = new Swiper(slider, {
      slidesPerView: 1.3,
      spaceBetween: 12,

      breakpoints: {
        480: {
          slidesPerView: 2.1,
        },
        768: {
          slidesPerView: 3.2,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('insta-feed-wrap')) {
  customElements.define('insta-feed-wrap', InstaFeedSlider);
}